import React, { useContext } from "react";
import { Stats } from "@react-three/drei";

import { useViewerStateStore } from '../../store/viewerStateStore';
import CameraLayersLogger from "./CameraLayersLogger";
import BoundingBoxVisualizer from "./BoundingBoxVisualizer";

const DebugHelper = () => {
  const { isDebugMode } = useViewerStateStore();

  return (
    <>
      {isDebugMode && <Stats />}

      {/* Helper which outputs current camera layers to console */}
      {isDebugMode && <CameraLayersLogger />}

      {/* Visualizes the model bounding box stored in modelPropertiesStore */}
      {isDebugMode && <BoundingBoxVisualizer />}
    </>
  );
};

export default DebugHelper;
